import axios from "axios";
import { recordError } from "@/lib/activity";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("pressops_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  const b = localStorage.getItem("pressops_branch");
  if (b && b !== "all") c.headers["X-Branch-Id"] = b;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status >= 400) recordError(e);
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login")) {
      const ops = localStorage.getItem("pressops_ops_token");
      if (ops) {
        localStorage.setItem("pressops_token", ops);
        localStorage.removeItem("pressops_ops_token");
        localStorage.removeItem("pressops_user");
        window.location.href = "/ops";
        return Promise.reject(e);
      }
      localStorage.removeItem("pressops_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const fmt = (n, cur = "GHS") =>
  `${cur} ${Number(n || 0).toLocaleString("en-GH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fdate = (s) =>
  s ? new Date(s).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const fdatetime = (s) =>
  s ? new Date(s).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
